

export const navOfficerItems = [{
  title: 'Dashboard',
  icon: 'la-home',
  page: '/system/dashboard',
},
// { section: 'ครูที่ปรึกษา', icon: 'la-ellipsis-h' },
{
  title: 'ครูที่ปรึกษา',
  icon: 'la la-chalkboard-teacher',
  page: 'null',
  roles: ['DEV', 'ADMIN', '09'],
  // badge: { type: 'badge-info', value: '12' },
  submenu: {
    items: [
      {
        title: 'เช็คแถว/โฮมรูม',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/checkrow',
        id: '',

      },
      // {
      //   title: 'โฮมรูม',
      //   icon: 'la-chevron-circle-right',
      //   page: '/system/teacher/homeroom',
      //   id: '',

      // },
      {
        title: 'ที่ปรึกษา',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/consult',
        id: '',

      },
      {
        title: 'คะแนนความประพฤติ',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/score',
        id: '',

      },
      {
        title: 'เยี่ยมบ้าน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/visithome',
        id: '',

      },
      {
        title: 'รายงานเยี่ยมบ้าน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/report/visithome',
        id: '',

      },
      {
        title: 'SDQ',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/tea-sdq',
        id: '',

      },
      {
        title: 'รายงาน SDQ',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/report/sdq',
        id: '',

      }
    ]
  }
},
{
  title: 'ครูผู้สอน',
  icon: 'la la-chalkboard-teacher',
  page: 'null',
  roles: ['DEV', 'ADMIN', '10'],
  // badge: { type: 'badge-danger', value: '12' },
  submenu: {
    items: [
      {
        title: 'เช็ครายคาบ',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/checkclass',
        id: ''

      },

      {
        title: 'วิชาสอน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/other/subject',
        id: ''
      },
      {
        title: 'กิจกรรมพัฒนาผู้เรียน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/activity',
        id: ''
      },
      {
        title: 'ตารางสอน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/timetable',
        id: ''

      },
      {
        title: 'การบ้าน',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/homework',
        id: ''

      },
      {
        title: 'คะแนนเก็บ',
        icon: 'la-chevron-circle-right',
        page: '/system/teacher/other/score',
        id: ''

      },

    ]
  }
},
// {
//   title: 'ระบบเยี่ยมบ้าน',
//   icon: 'la la-chalkboard-teacher',
//   page: '/system/teacher/report/visithome',
//   id: '',
//   roles: ['DEV', 'ADMIN', '12'],
// },
// {
//   title: 'SDQ',
//   icon: 'la la-file-text',
//   page: '/system/registration',
//   id: '',
// },

{ section: 'APP', icon: 'la-ellipsis-h' },
{
  title: 'menu_registration_main',
  icon: 'la-users',
  page: '/system/registration',
  id: '',
  roles: ['DEV', 'ADMIN', '02'],
},
{
  title: 'menu_goverment_main',
  icon: 'la-user-shield',
  page: 'null',
  // page: '/system/goverment',
  roles: ['DEV', 'ADMIN', '01'],
  id: '',
  submenu: {
    items: [

      {
        title: 'หัก/เพิ่ม คะแนน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/scoretrans',
        id: ''
      },
      {
        title: 'กลุ่มการหักคะแนน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/groupscorecut',
        id: ''
      },
      {
        title: 'กลุ่มการเพิ่มคะแนน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/groupscoreadd',
        id: ''
      },
      {
        title: 'บันทึกใบลา',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/leave',
        id: ''
      },
      {
        title: 'ลงเวลาสแกน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/scan-manual',
        id: ''
      },
      {
        title: 'จัดการวันหยุด',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/holiday',
        id: ''
      },
      {
        title: 'จัดการกลุ่มสแกน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/groupscan',
        id: ''
      },
      // {
      //   title: 'จัดการบัตรนักเรียน',
      //   icon: 'la-chevron-circle-right',
      //   page: '/system/goverment/card-student',
      //   id: ''
      // },
      {
        title: 'เอกสารนักเรียน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/document',
        id: ''
      },
      { section: 'รายงาน', icon: 'la-ellipsis-h', page: 'null', },
      {
        title: 'รายงานการสแกนเข้า-ออก',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/report/scan-daily-in',
        id: ''
      },
      {
        title: 'รายงานการเช็คแถว/โฮมรูม',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/report/check-row',
        id: ''
      },
      // {
      //   title: 'รายงานการเช็คโฮมรูม',
      //   icon: 'la-chevron-circle-right',
      //   page: '/system/goverment/report/homeroom',
      //   id: ''
      // },
      {
        title: 'รายงานการหักคะแนน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/report/cutscore',
        id: ''
      },
      {
        title: 'รายงานการเพิ่มคะแนน',
        icon: 'la-chevron-circle-right',
        page: '/system/goverment/report/addscore',
        id: ''
      },
    ]
  }
},
{
  title: 'menu_academic_main',
  icon: 'la la-paste',
  page: '/system/academic',
  id: '',
  roles: ['DEV', 'ADMIN', '03'],
},
{
  title: 'menu_evoluation_main',
  icon: 'la-chart-bar',
  page: '/system/evoluation',
  id: '',
  roles: ['DEV', 'ADMIN', '04'],
},
{
  title: 'งานบุคลากร',
  icon: 'la la-users',
  page: '/system/personal',
  id: '',
  roles: ['DEV', 'ADMIN', '06'],
},
{
  title: 'งานอาคารเรียน',
  icon: 'la la-city',
  page: '/system/building',
  id: '',
  roles: ['DEV', 'ADMIN', '140101'],
},
{
  title: 'menu_advertise_main',
  icon: 'la la-newspaper-o',
  page: '/system/advertise',
  id: '',
  roles: ['DEV', 'ADMIN', '05'],
},


  // {
  //   title: 'menu_admission',
  //   icon: 'la-rss-square',
  //   page: '/system/admission',
  //   id: ''
  // },

  // {
  //   title: 'คู่มือใช้งานระบบ',
  //   icon: 'la la-file-text',
  //   page: '/system/user-manual',
  //   id: ''
  // },
];